var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_c('div',{staticClass:"tabs-bar"},_vm._l((_vm.navList),function(item,index){return _c('div',{key:item.name,class:_vm.tabCls(item),on:{"click":function($event){return _vm.handleChange(index)}}},[_vm._v("\n      "+_vm._s(item.label)+"\n    ")])}),0),_c('div',{staticClass:"tabs-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }